angular.module('core')
  .directive('confirmMessage', function() {
    return {
      restrict: 'E',
      scope: {
         itemReady: '=',
         okayButtonText: '@',
         title: '@',
         message: '@'
      },
      controller: ['$scope', 'dblModalService', function($scope, dblModalService) {

        $scope.$watch('itemReady', function(newVal) {
          if (newVal) {
            dblModalService.openConfirmModal({
                okayButtonText: $scope.okayButtonText,
                title: $scope.title,
                message: $scope.message
            });
          }
        });
     }]
  };
});
